<template>
  <div id="app">
    <router-view></router-view>
    <van-image-preview
      v-model="swiperShow"
      :images="showImgs"
      :startPosition="swipercliclIndex"
      class="VanImgs"
    ></van-image-preview>
    <!-- 林地,古树 添加评论兼容地图页和详情页弹出层 -->
    <add-commont v-if="addItemShow"></add-commont>
  </div>
</template>

<script>
/* eslint-disable */

const addCommont = () => import("@/components/common/addCommont");

import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { mapState, mapMutations } from "vuex";
export default {
  name: "App",
  data() {
    return {
      showImgs: [], // 展示的img
      swiperShow: false,
      swipercliclIndex: 0,
      addItemShow: false, //评价是否显示
      clientType: "", //手机类型
    };
  },
  components: {
    addCommont,
  },
  mounted() {
    this.$nextTick(() => {
      this.clientType = getDeviceType();

      let hashName = document.location.hash.substr(2);
      let indexOfIndex = hashName.indexOf("?");

      let routerName =
        indexOfIndex > 0 ? hashName.substr(0, indexOfIndex) : hashName;

      if (
        routerName != "userNotice" &&
        routerName != "privacyPage" &&
        routerName != "gushuGis" &&
        routerName != "gushuDetail" &&
        routerName != "gushuRecord" &&
        routerName != "pubResourceMsg" &&
        routerName != "treeAnalyse" &&
        routerName != "gushuManage" &&
        routerName != "gushuRepair" &&
        routerName != "policyDetailTwo" &&
        routerName != "pubZqInfo"
      ) {
        this.getLoginInfo();
      }
    });
    //    routerName != "oldTree" &&
  },
  methods: {
    getLoginInfo() {
      let _this = this;
      _this.$api.User.loginInfo()
        .then((res) => {
          if (res.code == "1") {
            _this.$store.commit("setUserInfo", res.data);
          } else {
            if (res.code == "401") {
              _this.$toast("登录失效");
              setTimeout(function () {
                if (_this.clientType == "android") {
                  //安卓
                  window.android.getInfo(106, "1");
                } else {
                  //IOS
                  window.webkit.messageHandlers.closePage.postMessage("1");
                }
              }, 3000);
            } else {
              _this.$toast(res.msg);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    ...mapState(["showDataImgs", "addCommontType"]),
  },
  watch: {
    showDataImgs: {
      handler: function () {
        this.showImgs = this.showDataImgs.showImgs;
        this.swipercliclIndex = this.showDataImgs.swipercliclIndex;
        this.swiperShow = this.showDataImgs.swiperShow;
      },
      deep: true,
    },
    addCommontType: {
      handler: function () {
        console.log(this.addCommontType);
        this.addItemShow = this.addCommontType.type;
      },
      deep: true,
    },
  },
};
</script>

<style lang="less">
html,
body {
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
}
</style>